const makeNewMessageId=objectId=>`newMessage::${objectId}`;export default makeNewMessageId;